// removed by extract-text-webpack-plugin
module.exports = {"colors":"\"../../../styles/variables.css\"","textDefault":"#808080","container":"_2ACrdsvM88CeXEtPQQCXCJ","hidden":"_3tHxe7L-N4TO55ZL9hhbZN","title":"_1PZQiMgTqg4pWsSqxNj1Yy","content":"_1ZsVImm7SMBeEjQ1hwZebY","date":"hxAx-aMCiN6YtZXxF2C2F","time":"_3ojr7jwaNxOD7KOlzIR6fk","buttons-section":"_1rQw69DiZcD5o1sFj4iXcb","button":"QN5OzxqTDzPwCyg4OHqbL","button-icon":"XtQmZlSxqwM_0nHwlpZM0","button-text":"_2f1oDqJb0dFryfYCke3P0r","delete-button":"_36v4c3Xi3ui-O6_FNoLQ-x"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Journal/components/NoteViewer.mod.css
// module id = 1561
// module chunks = 0